import { useQuery } from '@tanstack/react-query';

import { getAgentsByRooftop } from 'api/agents';
import type { GetAgentByRooftopResponseDTO } from 'declarations/dto/agents';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchAgentsList = (
  isPopupOpened: boolean,
  rooftopIds: string[] | undefined
): ReturnType<typeof useQuery<GetAgentByRooftopResponseDTO[], ApiErrorI>> => {
  return useQuery<GetAgentByRooftopResponseDTO[], ApiErrorI>(
    [RequestQueryKeysE.FetchAgentsList, { rooftopIds }],
    (): Promise<GetAgentByRooftopResponseDTO[]> => {
      return getAgentsByRooftop(rooftopIds);
    },
    {
      enabled: isPopupOpened && !!rooftopIds,
    }
  );
};
